import React from 'react';
import CustomFilterSection from '../CustomFilterSection/CustomFilterSection';
import CustomHeroSection from '../CustomHeroSection/CustomHeroSection';
import NewReleaseSection from '../NewReleaseSection/NewReleaseSection';
import SeriesSection from '../SeriesSection/SeriesSection';
import FilmsSection from '../FilmsSection/FilmsSection';
import StreamsSection from '../StreamsSection/StreamsSection';
import PodcastsSection from '../PodcastsSection/PodcastsSection';
import {
  BINGE_WORTHY_ORIGINALS,
  COMING_SOON,
  CURRENTLY_WATCHING,
  FILMS_GENRE_FILTERS,
  FILMS_HERO,
  GENRE_FILTERS,
  SERIES,
  SERIES_HERO,
  CREATOR_GENRE_FILTERS,
  CREATOR_HERO,
  CUSTOM_FILTERS,
  FEATURED_CREATORS,
  FILMS,
  FOR_YOU,
  HERO,
  MY_CREATORS,
  NEW_RELEASES,
  RECENT_RELEASES,
  STREAMS_HERO,
  VERTICAL_VIDEOS_HERO,
  VERTICAL_VIDEOS_GENRE_FILTERS,
  STREAMS_GENRE_FILTERS,
  STREAMS,
  PODCASTS,
  PODCASTS_HERO,
  PODCASTS_GENRE_FILTERS,
} from '../../../../constants';
import ComingSoonSection from '../ComingSoonSection/ComingSoonSection';
import ForYouSection from '../ForYouSection/ForYouSection';
import FeaturedCreators from '../FeaturedCreators/FeaturedCreators';
import RecentlyWatchedSection from '../RecentlyWatchedSection/RecentlyWatchedSection';
import MyCreatorsSection from '../MyCreators/MyCreators';
import CreatorHeroSection from '../CreatorHeroSection/CreatorHeroSection';
import SeriesHero from '../SeriesHero/SeriesHero';
import SeriesGenre from '../SeriesGenre/SeriesGenre';
import FilmsHero from '../FilmsHero/FilmsHero';
import FilmsGenre from '../FilmsGenre/FilmsGenre';
import StreamsHero from '../StreamsHero/StreamsHero';
import VerticalVideosHero from '../VerticalVideosHero/VerticalVideosHero';
import StreamsGenre from '../StreamsGenre/StreamsGenre';
import PodcastsHero from '../PodcastsHero/PodcastsHero';
import PodcastsGenre from '../PodcastsGenre/PodcastsGenre';
import VerticalVideosGenre from '../VerticalVideosGenre/VerticalVideosGenre';
import CreatorsWithRecentlyReleases from '../CreatorsWithRecentlyReleases/CreatorsWithRecentlyReleases';
import CreatorGenres from '../CreatorGenres/CreatorGenres';
import BingeWorthyOriginalsSection from '../BingeWorthyOriginalsSection/BingeWorthyOriginalsSection';

const OtherSection = ({ sectionName, description, currentUser }) => {
  const renderComponent = sectionName => {
    switch (sectionName) {

      // Landing Page Sections
      case HERO:
        return <CustomHeroSection />;

      case CUSTOM_FILTERS:
        return <CustomFilterSection />;

      case FOR_YOU:
        return <ForYouSection sectionName={sectionName} description={description} />;

      case CURRENTLY_WATCHING:
        return <RecentlyWatchedSection sectionName={sectionName} description={description} />;

      case MY_CREATORS:
        return <MyCreatorsSection sectionName={sectionName} description={description} />;

      case NEW_RELEASES:
        return <NewReleaseSection sectionName={sectionName} description={description} />;

      case SERIES:
        return <SeriesSection sectionName={sectionName} description={description} currentUser={currentUser} />;

      case FILMS:
        return <FilmsSection sectionName={sectionName} description={description} currentUser={currentUser} />;

      case STREAMS:
        return <StreamsSection sectionName={sectionName} description={description} currentUser={currentUser} />;

      case PODCASTS:
        return <PodcastsSection sectionName={sectionName} description={description} currentUser={currentUser} />;

      case COMING_SOON:
        return <ComingSoonSection sectionName={sectionName} description={description} />;

      case FEATURED_CREATORS:
        return <FeaturedCreators sectionName={sectionName} description={description} currentUser={currentUser} />;

      case RECENT_RELEASES:
        return <CreatorsWithRecentlyReleases sectionName={sectionName} description={description} currentUser={currentUser} />;

      case BINGE_WORTHY_ORIGINALS:
        return <BingeWorthyOriginalsSection sectionName={sectionName} description={description} currentUser={currentUser} />;

      case CREATOR_GENRE_FILTERS:
        return <CreatorGenres/>;

      case CREATOR_HERO:
        return <CreatorHeroSection />;

      // Series Page Sections
      case SERIES_HERO:
        return <SeriesHero />;

      case GENRE_FILTERS:
        return <SeriesGenre />;


      // Films Page Sections
      case FILMS_HERO:
        return <FilmsHero />;

      case FILMS_GENRE_FILTERS:
        return <FilmsGenre />;

      // Streams Page Sections
      case STREAMS_HERO:
        return <StreamsHero />;

      case STREAMS_GENRE_FILTERS:
        return <StreamsGenre />;

      // Podcasts Page Sections
      case PODCASTS_HERO:
        return <PodcastsHero />;

      case PODCASTS_GENRE_FILTERS:
        return <PodcastsGenre />;

      // Vertical Videos Page Sections
      case VERTICAL_VIDEOS_HERO:
        return <VerticalVideosHero />;

      case VERTICAL_VIDEOS_GENRE_FILTERS:
        return <VerticalVideosGenre />;

      default:
        console.warn(`Section ${sectionName} not found in Other sections!`);
        return null;
    }
  };

  return renderComponent(sectionName);
};

export default OtherSection;
